// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7g4Fe","left":"styles_left__Bppmo"};